import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=f9d5a29c&scoped=true"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"
import style0 from "./pc.vue?vue&type=style&index=0&id=f9d5a29c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d5a29c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home/examintro/pc.vue
// module id = null
// module chunks = 